<template>
    <div class="light-bulb" :class="lightStatus ? 'light-on': 'light-off'" @click="toggleSwitch(lightId)"> </div>
</template>

<script>
export default {
    inject: ["toggleSwitch"],
    props: {
        lightStatus: {
            required: true,
            type: Boolean
        },
        lightId: {
            required: true,
            type: Number
        },
    }
}
</script>

<style scoped>
.light-bulb{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
    cursor: pointer;
}
.light-on{
    background: #11dbca;
    box-shadow: 0 0 1.5px 1.5px #11dbca;
}
.light-off{
  background: #0D7377;
}
</style>